<template>
  <el-dialog :visible.sync="dialogVisible" @close="close" width="730px" :close-on-click-modal="false">
    <div style="position: relative">
      <div class="header">
        <img src="../../../assets/img/inviteHeader.png" alt="" />
      </div>
      <div class="body">
        <div class="section">
          <div class="section_title">
            方式一：微信邀请<span style="color: #62605f; font-size: 16px"
              >（手机端即可完成操作）</span
            >
          </div>
          <div class="section_desc">
            请您用微信扫一扫下方二维码，在手机上登录，通过“个人>邀请返利”分享给您的好友
          </div>
          <div class="section_qr">
            <div class="qr_code">
              <img class="inviteCode" src="../../../assets/img/navi_code.jpg" />
            </div>
            <div class="qr_desc">（特别说明:请用手机扫码登陆，再分享邀请好友返利。）</div>
          </div>
        </div>
        <div class="section">
          <div class="section_title">方式二：链接邀请</div>
          <div class="section_desc">复制下方链接，发送给好友（建议在电脑端打开链接）</div>
          <div class="section_content">
            <div class="section_content_title">专属邀请链接: {{ baseUrl }}</div>
            <div class="section_content_btn" @click="copyUrl">复制链接</div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { inviteFriends } from "@/api/request";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      dialogVisible: true,
      QrCode: "",
      baseUrl: "",
    };
  },
  mounted() {
    this.getQrCode();
  },
  methods: {
    getQrCode() {
      inviteFriends({ width: 300, inviterType: 1 }).then((res) => {
        let byteData = res.qrCodeBytes;
        // 创建图像的 URL
        this.QrCode = "data:image/png;base64," + byteData;
        let userInfo = this.$store.getters.userInfo
        let baseUrl = "https://www.navi-sci.cn?inviterType=3&aff=" + userInfo.clientId;
        this.baseUrl = baseUrl;
      });
    },
    copyUrl(){
        navigator.clipboard.writeText(this.baseUrl)
        .then(() => {
            this.$message.success("邀请链接已复制到剪贴板");
        })
        .catch((error) => {
            this.copyFlag = false
            this.$message.warning('复制失败,请手动复制邀请链接');
        });
    },
    close(){
        this.$emit('close')
    }
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 609px;
  height: 273px;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
  }
}
.body {
  // width: 809px;
  // height: 373px;
  background: #fdf4bc;
  border-radius: 25px 25px 0 0;
  margin-top: -40px;
  padding: 40px 20px;
  .section {
    .section_title {
      font-size: 18px;
      color: #322c2b;
    }
    .section_desc {
      font-size: 14px;
      color: #333333;
      padding-top: 10px;
    }
    .section_qr {
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
      align-items: flex-end;
      color: #eb9036;
    }
    .section_content {
      background: #fdf6d8;
      position: relative;
      height: 150px;
      border-radius: 20px;
      padding-top: 20px;
      margin-top: 10px;
      padding-left: 20px;
      .section_content_title {
        font-weight: bold;
      }
      .section_content_btn {
        background: #eb9036;
        width: 100px;
        height: 30px;
        border-radius: 30px;
        color: #ffffff;
        text-align: center;
        line-height: 30px;
        position: absolute;
        right: 20px;
        top: 60px;
        cursor: pointer;
      }
    }
  }
}
.inviteCode {
  width: 136px;
  height: 136px;
  // border-radius: 50%;
  // position: absolute;
  // top: 426px;
  // left: 107px;
  z-index: 9999;
}
</style>
